// 预支同意和拒绝api
import request from '@/utils/request'

export const yuzhiApplyAgree = (params) => {
  return request({
    url: '/admin/yuzhiApply/agree',
    method: 'post',
    params
  })
}

// 拒绝接口
export const yuzhiApplyRefuse = (params) => {
  return request({
    url: '/admin/yuzhiApply/refuse',
    method: 'post',
    params
  })
}
